
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-31873eda\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./BreedingRhombusSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./BreedingRhombusSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31873eda\"}!../../../../vue-loader/lib/selector?type=template&index=0!./BreedingRhombusSpinner.vue"),
  /* scopeId */
  "data-v-31873eda",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/BreedingRhombusSpinner.vue
// module id = 1856
// module chunks = 1